import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { FormikProps, Formik, Form, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import InputDateTime from "../../../../components/Shared/InputDateTime";
import { InputSelectField } from "../../../../components/Shared/InputSelectField";
import { InputField } from "../../../../components/Shared/InputField";

interface IFormProps {
    t?: any | undefined;
    moduleState: any;
    setQuery: any;
    dropdowns: any;
    visibility: any;
    toastify: any;
    onClose?: any;
}

type TInputForm = {
    countries: [],
    cities: [],
    location_names: [],
    street_lines: [],
    coordinates: null
    toDate: null,
    fromDate: null,
};

const DEFAULT_FORM_STATE = {
    countries: [],
    cities: [],
    location_names: [],
    street_lines: [],
    coordinates: null,
    toDate: null,
    fromDate: null,
};

// @ts-ignore
function LocationFilter(props: IFormProps) {
    const { t, visibility, dropdowns } = props;
    const formRef: any = useRef();
    const [initFormState, setInitFormState] = useState<any>(DEFAULT_FORM_STATE);
    const [panelState, setPanelState] = useState<boolean>(false);

    const onSubmit = async (payloads: any) => {
        props.setQuery({
            ...props.moduleState,
            filters: payloads
        });
    };

    const onReset = () => {
        const base: any = formRef.current;
        if ( base ) {
            base.resetForm();
        }

        props.setQuery({
            ...props.moduleState,
            filters: []
        });
    };

    const onClose = () => {
        setPanelState(false);

        if ( props.onClose ) {
            props.onClose();
        }
    };

    useEffect(() => {
        if ( visibility ) {
            setPanelState(visibility);
            setInitFormState({...DEFAULT_FORM_STATE, ...props.moduleState.filters ?? []});
        }
    }, [visibility]);

    return (
        <>
            <div>
                <Sidebar
                    header={
                        <div className="bg-body-tertiary card-header">
                            <h5 className={ "card-title mt-0" }>{ t('advance filters') }</h5>
                            <p>{ t("using filters you can archive better result.") }</p>
                        </div>
                    }
                    visible={ panelState } position="left" onHide={ onClose } blockScroll={ true }
                    style={ { width: '800px' } }  closeOnEscape={ false }
                >
                    <div style={ {
                        height: '3px',
                        background: 'linear-gradient(90deg, var(--primary-color) 0%, rgba(33, 150, 243, 0) 50%)'
                    } }></div>
                    <Formik
                        innerRef={ formRef }
                        enableReinitialize={ true }
                        initialValues={ initFormState }
                        onSubmit={ onSubmit }
                    >
                        { (props: FormikProps<TInputForm>) => {
                            return (
                                <Form onSubmit={ props.handleSubmit }>
                                    <Row className={ "mt-4" }>
                                        <Col sm={ 12 } md={ 12 }>
                                            <Field component={ InputSelectField }
                                                   name="countries" autoFocus={ true }
                                                   options={ dropdowns?.countries }
                                                   placeholder={ t("select") + ' ' + t("countries") }
                                                   label={ t('countries') }
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 12 }>
                                            <Field component={ InputSelectField }
                                                   name="cities"
                                                   options={ dropdowns?.cities }
                                                   placeholder={ t("select") + ' ' + t("cities") }
                                                   label={ t('city') }
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 12 }>
                                            <Field component={ InputSelectField }
                                                   name="location_names"
                                                   options={ dropdowns?.location_names }
                                                   placeholder={ t("select") + ' ' + t("location name") }
                                                   label={ t('location name') }
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 12 }>
                                            <Field component={ InputSelectField }
                                                   name="street_lines"
                                                   options={ dropdowns?.street_lines }
                                                   placeholder={ t("select") + ' ' + t("street") }
                                                   label={ t('street') }
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 12 }>
                                            <Field component={ InputField }
                                                   name="coordinates"
                                                   label={ t("coordinates") }
                                                   placeholder={ t("enter") + ' ' + t("coordinates") }
                                                   formText={ t("latitude, longitude") }
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 6 }>
                                            <Field component={ InputDateTime }
                                                   name="fromDate"
                                                   type={ "datetime" }
                                                   label={ t("from date") }
                                                   isClearable={ true }
                                                   enableTimeStartOfDay
                                            />
                                        </Col>
                                        <Col sm={ 12 } md={ 6 }>
                                            <Field component={ InputDateTime }
                                                   name="toDate"
                                                   type={ "datetime" }
                                                   label={ t("to date") }
                                                   isClearable={ true }
                                                   enableTimeEndOfDay
                                            />
                                        </Col>
                                    </Row>
                                    <div className="filter filter-card-footer"
                                         style={ { width: '785px' } }>
                                        <Button type={ "submit" } disabled={ props.isSubmitting }
                                                tooltip={ t("to data save into database") }
                                                size={ "small" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-filter me-2" />
                                            { t("filter") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onReset }
                                                tooltip={ t("to make all fields empty") } className={ "ms-2" }
                                                size={ "small" } severity={ "warning" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-refresh me-2" />
                                            { t("reset") }
                                        </Button>
                                        <Button type={ "button" } disabled={ props.isSubmitting }
                                                onClick={ onClose }
                                                tooltip={ t("operation cancel") } className={ "ms-2" }
                                                size={ "small" } severity={ "danger" } outlined
                                                tooltipOptions={ { position: 'top' } }
                                        >
                                            <i className="pi pi-arrow-left me-2" />
                                            { t("close") }
                                        </Button>
                                    </div>
                                </Form>
                            );
                        } }
                    </Formik>
                </Sidebar>
            </div>
        </>
    );
}

LocationFilter.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(LocationFilter);
